import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ctaClickEvent, pageViewEvent } from "../services/adobeDataLayer";
import "./thankyou.css";

function Thankyou() {
  const params = new URLSearchParams(window.location.search);
  const leadid = params.get("id");
  const navigate = useNavigate();
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");
  }, []);

  //Gtag by mFilterIt
  useEffect(() => {
    window.mf_package_name = "com.icicibank_al";
    window.mf_tracking_type = "conversion";
    window.mf_page_id_click = "NA";
    window.mf_order_id = leadid;

    const gTag = document.createElement("script");
    gTag.async = true;
    gTag.src = "https://script.mfilterit.net/v3/e/client/com.icicibank_al.js";
    document.body.appendChild(gTag);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());

    return () => {
      document.body.removeChild(gTag);
    };
  }, []);

  const handleClick = () => {
    ctaClickEvent(
      "Back",
      "thank you page",
      "button",
      0,
      "https://campaigns.icici.bank.in/seniorCitizenBanking/awareness/index.html",
    );

    navigate("/");
  };

  return (
    <>
      <section>
        <div className="container">
          <div className="thank-you">
            <div className="margin-top" style={{ position: "relative" }}>
              <h2 className="">
                Thank you for your interest in <br /> ICICI Bank Senior Citizen
                Solution
              </h2>
              <div className="popup-icon">
                <img
                  src={process.env.PUBLIC_URL + "/dist/img/icon15.webp"}
                  width="89"
                  height="84"
                  alt="Thanks"
                />
              </div>

              <h3>Our representative will get in touch with you shortly</h3>

              <button
                href="/"
                onClick={handleClick}
                className="free_back thank_you_back"
              >
                Go back
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Thankyou;
